import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'

import UsePagination from '../../../../components/pagination'
import { Loader } from '../../../../components/UI'

import { getLoginHistory } from '../../../../routing/fetchingfunction/user/user.action'
import {
  selectLoadingGetLoginHistory,
  selectLoginHistoryPagination,
} from '../../../../routing/fetchingfunction/user/user.reducer'

import { getPaginationTotalLength } from '../../../../helpers'

const MyHistory = () => {
  const dispatch = useDispatch()

  const { loginHistory, loginHistoryPage, loginHistoryPageSize, loginHistoryTotal } = useSelector(
    selectLoginHistoryPagination
  )
  const isLoading = useSelector(selectLoadingGetLoginHistory)

  const handlePageChange = (_, value) => {
    if (loginHistoryPage !== value) {
      dispatch(
        getLoginHistory({
          page: value,
        })
      )
    }
  }

  useEffect(() => {
    dispatch(
      getLoginHistory({
        page: loginHistoryPage || 1,
      })
    )
  }, [])

  const loginHistoryContent = loginHistory.map((loginHistoryItem) => {
    return (
      <p
        key={loginHistoryItem.logged_in_time}
        className="text-sm font-normal text-primary-100 leading-[20px]"
      >
        {`You have logged in at ${moment(loginHistoryItem.logged_in_time).format('LLL')} using ${loginHistoryItem.os} ${loginHistoryItem.device} from ${loginHistoryItem.city_location}, ${loginHistoryItem.country_location}`}
      </p>
    )
  })

  return (
    <div className="mt-[24px] border-[1px] border-solid border-[#FFCA84] rounded-[10px] p-[20px]">
      <h4 className="text-sm text-primary-100 font-semibold">My History Activity</h4>

      {loginHistory.length ? (
        <div className="flex flex-col gap-y-[10px] mt-[10px]">{loginHistoryContent}</div>
      ) : (
        isLoading && (
          <div className="flex items-center justify-center w-full mt-[10px]">
            <Loader className="text-primary-100" />
          </div>
        )
      )}

      {loginHistoryTotal > loginHistoryPageSize && (
        <div className="w-full flex items-center justify-center">
          <UsePagination
            count={getPaginationTotalLength(loginHistoryTotal, loginHistoryPageSize)}
            page={loginHistoryPage}
            onChange={handlePageChange}
            loading={isLoading}
            altColors
          />
        </div>
      )}
    </div>
  )
}

export default MyHistory
